export class Interceptor {
    constructor(type) {
        this.type = 'request';
        this.list = [];
        this.type = type;
    }
    use(params, priority = 'normal') {
        const interceptorId = `${this.type}-${Math.random()}`.replace('.', '');
        const { resolve, reject, namespace = 'common', type = 'normal' } = params;
        this.list[priority === 'high' ? 'unshift' : 'push']({
            resolve,
            reject,
            namespace,
            type,
            interceptorId,
        });
        return interceptorId;
    }
    eject(interceptorId) {
        const index = this.list.findIndex(item => item.interceptorId === interceptorId);
        index !== -1 && this.list.splice(index, 1);
    }
    excute(params, _filterCondition) {
        return this.list
            .filter(item => {
            if (typeof _filterCondition === 'function') {
                return _filterCondition(item.namespace || 'common', item.type || 'normal');
            }
            return true;
        })
            .reduce((total, current) => {
            const { resolve, reject } = current;
            total = total.then(resolve);
            if (typeof reject === 'function') {
                total = total.catch(reject);
            }
            return total;
        }, params);
    }
}
